export const HEADER_BLOCK_S26 = {
  "temp":{
    "templateId":26
  },
  "blockType": "HEADER",
  "blockDesign": "HeaderDesign2",
  "editFormName": "HEADER_04_FORM",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#060F11",
    "padding": "120px 20px 120px 20px"
  },
  "textBlock": {
    "styleProps": {
      "background-color": "",
      "border-radius": "0",
      "padding": "10px 10px 10px 10px"
    },
    "stylePropsTab": {},
    "stylePropsMob": {},
    "alingBlock": "center",
    "headings": [
      {
        "text": "Growth",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "4px"
        },
        "styleProps": {
          "color": "#ADFF85",
          "font-size": "1.25rem",
          "line-height": "1.75rem",
          "font-weight": "400",
          "font-family-cust": "",
          "font-family": ""
        },
        "alignStyleProps": {
          "text-align": "left",
          "margin": "0px 0px 0px 0px",
          "padding": "0px 20px 0px 20px"
        },
        "stylePropsMob": {
          "font-size": "1.125rem",
          "line-height": "1.75rem"
        },
        "stylePropsTab": {
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        }
      },
      {
        "text": "Transforming Businesses with Innovative Software Solutions",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "1px"
        },
        "styleProps": {
          "color": "#ffffff",
          "font-size": "3rem",
          "line-height": "1",
          "font-family": "",
          "font-weight": "400",
          "font-family-cust": "",
          "font-family-bk": "'Lato', sans-serif"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "10px 20px 10px 20px",
          "margin": "10px 0px 40px 0px"
        },
        "stylePropsMob": {
          "font-size": "2.25rem",
          "line-height": "2.5rem"
        },
        "stylePropsTab": {
          "font-size": "3rem",
          "line-height": "1"
        }
      },
      {
        "text": "Empowering growth, efficiency, and success through cutting-edge technology",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#b9b9cb",
          "font-size": "1.5rem",
          "line-height": "1.75rem"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "0px 20px 0px 20px"
        },
        "stylePropsTab": {
          "font-size": "1.5rem",
          "line-height": "2rem"
        },
        "stylePropsMob": {
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        }
      }
    ],
    "dynamicText": {
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "strings": []
    },
    "descriptionsStyleProps": {
      "padding": "10px 0px 10px 0px",
      "text-align": "center",
      "margin": "0px 0px 0px 0px"
    },
    "descriptionsStylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptionsStylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptions": [],
    "buttonsStyleProps": {
      "margin": "50px 0px 0px 0px"
    },
    "buttonAlign": "start",
    "buttons": [
      {
        "styleProps": {
          "padding": "12px 10px 12px 10px",
          "border-width": "0px",
          "color": "#ADFF85",
          "background-color": "",
          "border-radius": "9999px",
          "border-color": "#ffffff33",
          "font-size": "1rem",
          "line-height": "1.5rem"
        },
        "alt": "Google Play Store",
        "href": "#",
        "text": "LEARN MORE  ➜",
        "openType": "sametab"
      }
    ],
    "emailSecStyleProps": {},
    "subscription": {
      "showSection": "hide",
      "display": "enable",
      "subConfigs": {
        "configType": "convertkit",
        "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
        "configPlaceholder": ""
      },
      "email_placeholder": {
        "text": "example@mail.com"
      },
      "buttonText": {
        "text": "Subscribe",
        "styleProps": {
          "background-color": "#1b1b31",
          "color": "#ffffff"
        }
      },
      "successMessage": {
        "text": "Thank you for the signup",
        "styleProps": {}
      },
      "errorMessage": {
        "text": "Something went wrong. Please try again.",
        "styleProps": {}
      }
    }
  },
  "imageType": "image",
  "imageVideoPostion": "left",
  "imageBlock": {
    "image": "https://images.pexels.com/photos/207580/pexels-photo-207580.jpeg?auto=compress&cs=tinysrgb&w=600",
    "styleProps": {
      "margin": "20px 20px 20px 20px",
      "border-radius": "0px"
    },
    "outerStyleProps": {
      "border-radius": "1.5rem"
    },
    "tagStyleProps": {
      "border-radius": "1.5rem"
    }
  },
  "videoBlock": {
    "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
    "styleProps": {
      "margin": "20px 20px 20px 20px"
    },
    "videoHeight": {
      "height": "400px"
    }
  },
  "htmlBlock": {
    "value": "",
    "styleProps": {}
  },
  "metaDataId": 1746176636646,
  "afterIndex": 16,
  "blockId": 1746176636646,
  "buttons": [
    {
      "text": "Click Here",
      "styleProps": {
        "color": "#ffffff",
        "border-color": "#3b82f680"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "fonts": {
    "textBlock": ""
  },
  "position": "hide",
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}